export const DEFAULT_BACKGROUND_COLOR = 'rgba(0,0,0,0)'
export const DEFAULT_PEN_COLOR = '#000'
export const DEFAULT_WIDTH = '100%'
export const DEFAULT_HEIGHT = '100%'
export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml']
